import type { ForwardRefExoticComponent, RefAttributes } from "react";
import RenderReviewDialogImpl from "./RenderReviewDialogImpl.jsx";

export interface RenderReviewDialogProps {
  logEntry: any;
  onQuotePane?:
    | ((quoteData: {
        screen: string;
        screenLabel: string;
        component?: string;
        componentKey?: string;
      }) => void)
    | null;
  onCopyToAction?: (content: string, label: string) => Promise<void> | void;
  onCopyToInsight?: (content: string, label: string) => Promise<void> | void;
  notes?: Record<string, unknown>;
  processId?: string;
  isProcessOwner?: boolean;
  prologue?: string;
  epilogue?: string;
  isEditMode?: boolean;
  onPrologueChange?: (value: string) => void;
  onEpilogueChange?: (value: string) => void;
  onUserDataChange?: (fieldKey: string, value: unknown) => void;
  /** Recording metadata blobs from MinimalEditor / process API */
  prologueRecordings?: unknown;
  epilogueRecordings?: unknown;
  onNotesChange?: (notes: Record<string, unknown>) => void;
  exampleCreatorName?: string;
  onNext?: () => void;
  onPrevious?: () => void;
  /**
   * Full prescription diagram `data` map (activityId → activity dialog).
   * Used by personal_diagram to resolve option labels for bound fields.
   */
  diagramData?: Record<string, unknown> | null;
  /** Direct prescription ID — used in edit mode where processId is undefined */
  prescriptionId?: string;
}

const RenderReviewDialog = RenderReviewDialogImpl as ForwardRefExoticComponent<
  RenderReviewDialogProps & RefAttributes<unknown>
>;

export default RenderReviewDialog;
